module.exports = __webpack_public_path__ + "img/0x8c07b4c9f5bc170a3922eac4f5bb7ef17b0acc8b.0b2a8fb3.png";